module.exports = __webpack_public_path__ + "img/check-circle.cfcbf379.svg";